import { render, staticRenderFns } from "./privateData.vue?vue&type=template&id=1566086a&scoped=true&"
import script from "./privateData.vue?vue&type=script&lang=js&"
export * from "./privateData.vue?vue&type=script&lang=js&"
import style0 from "./privateData.vue?vue&type=style&index=0&id=1566086a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1566086a",
  null
  
)

export default component.exports